import {configureStore} from '@reduxjs/toolkit';
import {enableMapSet} from 'immer';

import sessionReducer from '../reducers/sessionReducer';
import billingReducer from '../reducers/billingReducer';
import consumerReducer from '../reducers/consumerReducer';
import accessReducer from '../reducers/accessReducer';
// import duplexReducer from '../reducers/duplexReducer';

enableMapSet();

export const store = configureStore({
    reducer: {
        access: accessReducer,
        session: sessionReducer,
        billing: billingReducer,
        consumer: consumerReducer,
        // duplex: duplexReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: ['payload', 'session/addTranslatedText', 'meta.arg.input.device', 'meta.arg.translation'],
                // Ignore these field paths in all actions
                ignoredActionPaths: [
                    'payload.device',
                    'payload',
                    'session/addTranslatedText',
                    'meta.arg.input.device',
                    'meta.arg.translation',
                    /^meta\.arg\.outputs\.\d+\.device$/,
                ],
                // Ignore these paths in the state
                ignoredPaths: ['session.translations', 'session.input.device', 'payload.device', 'payload', 'session.outputs', 'payload.device',
                    'session.currentTranslations', 'consumer.translationMap',
                    // Duplex device references (MediaDeviceInfo is not serializable)
                    'duplex.left.inputDevice', 'duplex.left.outputDevice',
                    'duplex.right.inputDevice', 'duplex.right.outputDevice',
                    // All recognizedTexts entries (circular buffer — not serializable)
                    /^session\.recognizedTexts\.\d+$/,
                    // Two-way panel device references (MediaDeviceInfo is not serializable)
                    /^session\.bidirectionalPanels\.\d+\.inputDevice$/,
                    /^session\.bidirectionalPanels\.\d+\.outputDevice$/,
                ]
            }
        })
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Expose store for benchmark data collection
if (typeof window !== 'undefined' && (window as any).__BENCHMARK_ENABLED__) {
    (window as any).__REDUX_STORE__ = store;
}


